"use strict";

import Vue from 'vue';
import axios from "axios";
import router from '../router';
import '../config';

import common from '../assets/common'
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
   baseURL: _APIURL_
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    try{
      // if(plus.networkinfo.getCurrentType() == 1){
      //   router.push({
      //       name: 'wifi'
      //   })
      // }
    }catch(e){
      
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    if (error.response) {
        switch (error.response.status) {
            case 403:
                router.push({
                    path: 'login'
                })
                break
            default:
              // debugger;
              // var dd=common;
                //兵哥要求改的 
                common.showPopup(this,'远程服务出错：'+rror.response.status);
                router.push({
                    path: 'errPage'
                })
                break
        }
    }
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
